export const columns = () => {
  return [
    {
      id: "product.code",
      accessorFn: (row) => row.product.code && `${row.product.code} - ${row.product.name}`,
      header: "Product",
    },
    {
      id: "gender.code",
      accessorFn: (row) => row.gender.code && `${row.gender.code} - ${row.gender.name}`,
      header: "Gender",
    },
    {
      id: "product_size.code",
      accessorFn: (row) =>
        row.product_size.code && `${row.product_size.code} - ${row.product_size.name}`,
      header: "Size",
    },
  ];
};
